import { COUNTERPARTY_ADMIN_SOLUTION_ID } from "./ready-solution-admin.mjs";

export const COUNTERPARTY_SOLUTION_NAME = "Справка о контрагенте";

export function solutionDisplayName(solution) {
  return solution?.solutionId === COUNTERPARTY_ADMIN_SOLUTION_ID
    ? COUNTERPARTY_SOLUTION_NAME : solution?.name;
}

export function taskSolutionName(task, solution) {
  if (task?.solutionId === COUNTERPARTY_ADMIN_SOLUTION_ID) return COUNTERPARTY_SOLUTION_NAME;
  return solution?.name || task?.solutionDescriptor?.name || "Не указано";
}

// Use the immutable launch snapshot, never the latest catalog publication.
export function taskSolutionVersion(task) {
  for (const version of [task?.solutionVersionRef?.version, task?.solutionDescriptor?.version]) {
    if (typeof version === "string" && version.trim()) return version.trim();
  }
  return null;
}
